import { createClient } from '@supabase/supabase-js';
import { getSupabaseConfig } from './lib/config';

const { url, key, isConfigured } = getSupabaseConfig();

/** False when REACT_APP_SUPABASE_* env vars are missing at build time. */
export const supabaseConfigured = isConfigured;

export const supabase = isConfigured
  ? createClient(url, key, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
